import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'cft-sidenav-items',
  templateUrl: './sidenav-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavItemsComponent {
  @Input()
  readonly placement!: SidenavItemsPlacement
}

export type SidenavItemsPlacement = 'main' | 'secondary'
